<template>
  <div ref="marker" @mouseenter="enter" @mouseleave="leave" :style="noteStyle">
    #{{ number }}
  </div>
</template>

<script>
export default {
  props: [ "number", "text", "color", "data-id" ],
  methods: {
    async enter() {
      this.$emit("mouseenter")
    },
    leave() {
      this.$emit("mouseleave")
    },
  },
  computed: {
    noteStyle() {
      return {
        width: this.calculatedWidth,
        padding: "2px",
        background: this.color,
        color: "white",
        cursor: "pointer",
        "border-radius": "0px 5px 5px 0px",
        "font-family": "monospace",
        "font-size": "12px",
        "z-index": 500,
        "position": "absolute"
      }
    },
    calculatedWidth() {
      const strNumber = `#${this.number}`
      return (strNumber.length * 13) + "px"
    }
  }
}
</script>